import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  inCompliance: {
    defaultMessage: 'In compliance',
    id: 'app.containers.WorkflowEditor.components.Rules.Condition.ComplianceStatus.inCompliance',
  },
  outOfCompliance: {
    defaultMessage: 'Out of compliance',
    id: 'app.containers.WorkflowEditor.components.Rules.Condition.ComplianceStatus.outOfCompliance',
  },
  pendingReview: {
    defaultMessage: 'Pending review',
    id: 'app.containers.WorkflowEditor.components.Rules.Condition.ComplianceStatus.pendingReview',
  },
});
